import React from 'react';
import StepOne from './StepOne';
// import StepTwo from './StepTwo';
import StepThree from './StepThree';
import { FormProvider } from 'react-hook-form';
import StepTwo from './StepTwo';
import { useProductCreationService } from '../../../../services/Products/hooks/useProductCreationService';

export default function AddNewProductDialog() {
  const {
    methods,
    handleSubmission,
    currentStep,
    handleSaveToDraft,
    handleStepOneSubmission,
    handleStepTwoSubmission,
  } = useProductCreationService();
  if (currentStep > 2) return null;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmission}>
        {currentStep == 0 && (
          <StepOne
            onNext={handleStepOneSubmission}
            onSaveToDraft={handleSaveToDraft}
          />
        )}
        {currentStep == 1 && <StepTwo onNext={handleStepTwoSubmission} />}
        {currentStep == 2 && <StepThree />}
      </form>
    </FormProvider>
  );
}
